import { CSSProperties } from 'react';
import styled, { css } from 'styled-components';

export const Frame = styled.label<{ width: CSSProperties['width'] }>`
  ${({ width }) => css`
    position: fixed;
    visibility: hidden;
    max-width: ${width ? `${width}px` : 'none'};
    z-index: -1;
  `}
`;
